import { render, staticRenderFns } from "./ProductMainTextBlock.vue?vue&type=template&id=3c8d927f&"
import script from "./ProductMainTextBlock.vue?vue&type=script&lang=js&"
export * from "./ProductMainTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports